import moment from "moment";
import Cookies from "universal-cookie";
import { takeEvery, put, select } from "redux-saga/effects";
import * as DomainActions from "./domainActions";
import { getLocale } from "../helpers";

import "moment/locale/fr";

export const watchDomainRequests = function* () {
    yield takeEvery(DomainActions.SET_LOCALE_LANG, fetchLocaleMessagesAsync);
};

const fetchLocaleMessagesAsync = function* () {
    const cookies = new Cookies();
    try {
        const locale = yield select(getLocale);
        const messages = yield loadLocaleData(locale.lang);

        // change moment locale for date and the cookie for refresh
        moment.locale(locale.lang);
        cookies.set("locale", locale.lang, { path: "/" });

        yield put(DomainActions.setMessages(messages));
    } catch (responseError) {}
};

function loadLocaleData(locale) {
    switch (locale) {
        case "fr":
            return import("./../../compiled-translations/fr.json");
        default:
            return import("./../../compiled-translations/en.json");
    }
}
